import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { SmartDevicesService } from '@app/modules/smart-devices/service/smart-devices.service';
import { DialogDeleteGenericComponent } from '@app/shared/components/dialog-delete-generic/dialog-delete-generic.component';
import { NotificationType } from '@app/shared/interfaces';
import { DeviceDetectionService } from '@app/shared/services/device-detection/device-detection.service';
import { ToastNotificationsService } from '@app/shared/services/toast-notifications/toast-notifications.service';
import { DeviceAccount } from '../../data/smart-devices.interface';

@Component({
  standalone: false,
  selector: 'sbnb-smart-device-connected-accounts-table',
  templateUrl: './smart-device-connected-accounts-table.component.html',
  styleUrls: ['./smart-device-connected-accounts-table.component.scss'],
})
export class SmartDeviceConnectedAccountsTableComponent implements OnInit {
  isMobile$ = this.deviceService.isMobileViewport();
  displayedColumns = ['image', 'name', 'connected', 'actions'];
  loading: boolean = false;

  @Input() accounts: DeviceAccount[];
  @Input() canAction = true;
  @Output() accountDeleted: EventEmitter<DeviceAccount> = new EventEmitter();

  constructor(
    private deviceService: DeviceDetectionService,
    private smartService: SmartDevicesService,
    private toast: ToastNotificationsService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void { }

  reconnectAccount(account: DeviceAccount) {
    this.loading = true;

    this.smartService.reconnectDeviceAccount(account.integration).subscribe((res) => {
      if (res) {
        this.loading = false;
        window.location.href = res;
      }
    });
  }

  deleteAccount(account: DeviceAccount) {
    const dialogRef = this.dialog.open(DialogDeleteGenericComponent, {
      width: '720px',
      data: {
        name: 'account',
        identifier: account.user_identifier,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.loading = true;

        this.smartService.deleteDeviceAccount(account).subscribe(
          (deleted) => {
            if (deleted) {
              this.accountDeleted.emit(account);
            } else {
              this.toast.open('Unable to delete account at this time', 'OK', NotificationType.Error);
            }
            this.loading = false;
          },
          (err) => {
            this.loading = false;
          }
        );
      }
    });
  }
}
